// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZiPpO","footer":"styles_footer__S5bVG","passCodeTooltip":"styles_passCodeTooltip__1irFe"};